var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.261719 0H11.4152C12.168 0 13.2788 0.212393 14.2315 0.881805C15.2363 1.58786 16.0014 2.76371 16.0014 4.5V21.135L8.99859 15.2994L1.9496 21.1234V4.5C1.9496 3.21796 1.94793 2.54089 1.89979 2.11137C1.86306 1.7836 1.81499 1.73116 1.76618 1.6779C1.76304 1.67448 1.7599 1.67105 1.75676 1.66754L0.261719 0ZM3.89871 2C3.94967 2.54969 3.94964 3.31666 3.94961 4.40891C3.94961 4.43903 3.9496 4.46939 3.9496 4.5V16.8766L9.00407 12.7006L14.0014 16.865V4.5C14.0014 3.4363 13.5711 2.86214 13.0816 2.5182C12.54 2.13761 11.8577 2 11.4152 2H3.89871Z",
    fill: "#0071E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.3c6120082db2c851c56bbfb40a4ee775.svg";
export { ForwardRef as ReactComponent };